import { MOBILE_LOCK_SCREEN_TIMEOUT } from "fieldpro-tools";
import _ from "lodash";

import { IOption } from "model/application/components";
import TLang from "model/application/Lang";

export const getMobileLockScreenTimeoutOptions = (lang: TLang) => {
  const label = lang.containers.clients.subCategories.clients.createEditModal;
  const options: IOption[] = [];

  const keys = _.keys(MOBILE_LOCK_SCREEN_TIMEOUT);
  _.each(keys, (key) => {
    switch (key) {
      case MOBILE_LOCK_SCREEN_TIMEOUT.ALWAYS:
        options.push({
          key: MOBILE_LOCK_SCREEN_TIMEOUT.ALWAYS,
          label: label.inputMobileLockScreenTimeout?.options[key],
          value: 0,
        });
        break;

      case MOBILE_LOCK_SCREEN_TIMEOUT.AFTER_30_MINUTES:
        options.push({
          key: MOBILE_LOCK_SCREEN_TIMEOUT.AFTER_30_MINUTES,
          label: label.inputMobileLockScreenTimeout?.options[key],
          value: 30,
        });
        break;

      case MOBILE_LOCK_SCREEN_TIMEOUT.AFTER_60_MINUTES:
        options.push({
          key: MOBILE_LOCK_SCREEN_TIMEOUT.AFTER_60_MINUTES,
          label: label.inputMobileLockScreenTimeout?.options[key],
          value: 60,
        });
        break;

      case MOBILE_LOCK_SCREEN_TIMEOUT.NEVER:
        options.push({
          key: MOBILE_LOCK_SCREEN_TIMEOUT.NEVER,
          label: label.inputMobileLockScreenTimeout?.options[key],
          value: null,
        });
        break;

      default:
        return undefined;
    }
  });

  return _.compact(options);
};
